<!-- data-testid lives on the OVERLAY, not the component host: the host is a
     zero-size box (its only child is position:fixed), which visibility-based
     waits reject even while the modal is open on screen (golden-path
     edit-open, 2026-07-23). -->
<div class="image-editor-overlay" data-testid="image-editor-overlay" *ngIf="visible" (click)="close()">
  <div class="image-editor-modal" (click)="$event.stopPropagation()">
    <div class="editor-header">
      <h3>Edit Image</h3>
      <div class="editor-header-actions">
        <button class="auto-enhance-btn" (click)="autoAlign()" [disabled]="loading || aligning" data-testid="auto-align-btn" data-tooltip="Auto-detect and straighten horizon" aria-label="Auto-detect and straighten horizon">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 6H3"/><path d="M21 12H3"/><path d="M21 18H3"/><path d="M7 3l-4 3 4 3"/></svg>
          {{ aligning ? 'Aligning...' : 'Auto Align' }}
        </button>
        <button class="auto-enhance-btn" (click)="rotate90('left')" [disabled]="loading || rotating" data-testid="image-rotate-left-btn" data-tooltip="Rotate left 90 degrees" aria-label="Rotate left 90 degrees">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2.5 2v6h6"/><path d="M2.66 15.57a10 10 0 1 0 .57-8.38"/></svg>
          Rotate left
        </button>
        <button class="auto-enhance-btn" (click)="rotate90('right')" [disabled]="loading || rotating" data-testid="image-rotate-right-btn" data-tooltip="Rotate right 90 degrees" aria-label="Rotate right 90 degrees">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21.5 2v6h-6"/><path d="M21.34 15.57a10 10 0 1 1-.57-8.38"/></svg>
          Rotate right
        </button>
        <button class="auto-enhance-btn" (click)="autoEnhance()" [disabled]="loading || enhancing" data-testid="auto-enhance-btn" data-tooltip="Auto-optimize brightness, contrast & saturation" aria-label="Auto-optimize brightness, contrast & saturation">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg>
          {{ enhancing ? 'Enhancing...' : 'Auto Enhance' }}
        </button>
        <button class="close-btn" (click)="close()" data-tooltip="Close" data-testid="image-editor-close" aria-label="Close">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>
    </div>
    <div class="editor-body">
      <div class="loading-indicator" *ngIf="loading">
        <div class="spinner"></div>
        <p>Loading editor...</p>
      </div>
      <div class="error-message" *ngIf="error">
        <p>{{ error }}</p>
        <button (click)="close()">Close</button>
      </div>
      <div #editorContainer class="editor-container" [class.hidden]="loading || error" data-testid="image-editor-container"></div>
    </div>
  </div>
</div>
